import $ from 'jquery';

window.$ = window.jQuery = $;
window.$ = window.jQuery = $.noConflict();

export class CollapseBlock {
    constructor() {

        // this.common();
        this.jQuery();

    }

    jQuery() {

        let first = $('.js-collapse-block').first();
        first.toggleClass('active');
        $(`#${first.attr('id')}-content`).toggle();

        $('.js-collapse-block').click(function (event) {
            event.preventDefault();

            let $this = $(this);

            $this.toggleClass('active');

            $(`#${$this.attr('id')}-content`).toggle();

        });
    }

    common() {
        this.items = document.querySelectorAll('.js-collapse-block');

        if (this.items.length <= 0) {
            return false;
        }

        this.applyEvents();


        setTimeout(() => {
            this.openBlock(this.items[0]);
        }, 100);
    }

    applyEvents() {

        this.items.forEach((collapseBlock) => {
            collapseBlock.onclick = this.clickEvent.bind(this);
        });

    }

    clickEvent(event) {
        event.preventDefault();

        let $this = event.target;


        this.openBlock($this);
    }

    openBlock(initialBlock) {
        let id = initialBlock.getAttribute('id') ?? '';

        if (id.length <= 0) {
            console.log('ID не найден');
            return false;
        }

        let contentId = `${id}-content`;
        var content = document.getElementById(contentId) ?? '';

        if (content.length <= 0) {
            console.log('Content блок не найден');
            return false;
        }

        initialBlock.classList.toggle("active");

        if (content.style.maxHeight) {
            content.style.maxHeight = null;
        } else {
            content.style.maxHeight = content.scrollHeight + "px";
        }

    }
}